// extracted by mini-css-extract-plugin
module.exports = {"w-full":"inputBlock_w-full__388ma","wFull":"inputBlock_w-full__388ma","w-half":"inputBlock_w-half__1EF27","wHalf":"inputBlock_w-half__1EF27","w-0":"inputBlock_w-0__10iU6","w0":"inputBlock_w-0__10iU6","h-full":"inputBlock_h-full__1_D_I","hFull":"inputBlock_h-full__1_D_I","label":"inputBlock_label__cYgUr","extraLabel":"inputBlock_extraLabel__133fr","text":"inputBlock_text__IfXk1","required":"inputBlock_required__3bKb0"};
    if(module.hot) {
      // 1745908278336
      var cssReload = require("!../../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  